import { uploadsActions } from '@anm/store/modules/uploads';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../../store/modules/hostedVideo';

const useReplaceVideoProgress = () => {
  const [showProgress, setShowProgress] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const uploadVideo = useSelector(hostedVideoSelectors.selectUploadVideo);

  const currentUploadProgress = uploadVideo?.progress;

  useEffect(() => {
    const canShow = !!(currentUploadProgress && !isCancelled);

    setShowProgress(canShow);
  }, [currentUploadProgress, isCancelled]);

  const dispatch = useDispatch();

  const handleCancelUpload = useCallback((id: string) => {
    setIsCancelled(true);
    dispatch(uploadsActions.cancelUploading({ uploadId: id }));
  }, []);

  return [showProgress, currentUploadProgress, isCancelled, handleCancelUpload] as const;
};

export default useReplaceVideoProgress;
